module.exports = __webpack_public_path__ + "img/154.5347523d.jpg";